import React from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";
import { useSelector } from "react-redux";

import PageHeader from "../../../Components/PageHeader/PageHeader";
import type { ApplicationState } from "../../../store";
import { FAQ_ITEMS } from "./faqContent";
import MenuPageBackLink from "../MenuShared/MenuPageBackLink";
import "./styles.css";

const FaqPage = () => {
  const idUsuario = useSelector(
    (state: ApplicationState) => state.auth.data?.idUsuario
  );
  const items = FAQ_ITEMS.filter(
    (item) => item.id !== 9 || idUsuario !== 26496
  );

  return (
    <section className="content-page faq-page" aria-label="FAQ">
      <MenuPageBackLink />

      <PageHeader
        title="FAQ"
        description="Respostas rápidas para as dúvidas mais frequentes sobre o Conectado."
      />

      <div className="faq-page__list">
        {items.map((item) => (
          <details key={item.id} className="faq-item">
            <summary>
              <span className="faq-item__number" aria-hidden="true">
                {item.id}
              </span>
              <span>{item.question}</span>
              <ExpandMoreRoundedIcon aria-hidden="true" />
            </summary>
            <div className="faq-item__answer">
              <HelpOutlineRoundedIcon aria-hidden="true" />
              <p>{item.answer}</p>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FaqPage;
